import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname } = useLocation();
    const action = useNavigationType();

    useEffect(() => {
        // If the action is PUSH or REPLACE (new page navigation), scroll to top.
        // If the action is POP (back/forward button), let the browser handle restoration.
        if (action !== "POP") {
            window.scrollTo(0, 0);
        }
    }, [pathname, action]);

    return null;
}
